<template>
  <v-app>
    <v-container class="py-0 px-4" justify-center>
      <!-- title row -->
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <p
            class="font-weight-bold"
            style="font-size: 40px !important; margin-bottom: 20px"
          >Our Website Services</p>
          <p
            class="subheading font-weight-light grey--text"
            style="max-width: 900px; margin: auto; margin-bottom: 70px"
          >
            We at Everowl Technology will assess and analyse your business needs and requirements before any development takes place to ensure that your website successfully achieves your desired business goals. 
            Our developers will then proceed with the best web design principles and practices to develop your stunning website that engages with your customer and drive sales leads.
          </p>
        </v-flex>
      </v-layout>
      <!-- 1st row -->
      <v-layout class="pulseAnimationHover" row wrap align-center style="border: 1px solid #dbdee5; margin-bottom: 20px ">
        <v-flex xs12 md5>
          <div style="height: 70%; width: 100%; text-align: center;">
          <img
              style="max-height: 100%; max-width: 100%; padding: 12%"
              src="/img/Web-Avatar-1.svg"
              alt="Web-Avatar-1.svg"
            >
          </div>
        </v-flex>

        <v-flex xs12 md7>
          <div class="px-5 pb-4 mb-1 pt-3">
            <h2 class="font-weight-bold" style="font-size: 28px !important">Website Design</h2>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p style="font-size: 15px !important; color: #6d7783;">
              Our approach to website design varies in order to allow an endless opportunity for creativity between the both of us.
              We either design a website ranging from templates that you like your website to be modelled after or trust us with our intuition and creativity.
              <transition name="fade">
              <span v-show="webDesignContent">Nonetheless, we will ensure that the design of your website not only exceeds your expectation but also provides a great form of functionality and user experience for your customers as well.</span>
              </transition>
              <div v-show="!webDesignContent">
                <a @click="(webDesignContent=!webDesignContent) (websiteDesignContentText='Read Less')" style="font-size: 15px !important; color: rgb(118, 142, 222)">{{websiteDesignContentText}}</a>
              </div>
              <!-- <div v-show="webDesignContent">
                <a @click="(webDesignContent=!webDesignContent) (websiteDesignContentText='Read More')" style="font-size: 15px !important; color: rgb(118, 142, 222)">{{websiteDesignContentText}}</a>
              </div> -->
            </p>
          </div>
        </v-flex>
      </v-layout>
      <!-- 2nd row -->
      <v-layout class="pulseAnimationHover" row wrap align-center style="border: 1px solid #dbdee5; margin-bottom: 20px">
        <v-flex xs12 md7>
          <div class="px-5 pb-4 pt-3">
            <h2 class="font-weight-bold" style="font-size: 28px !important">Website Application</h2>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p style="font-size: 15px !important; color: #6d7783;">
              The popularity of web application in Malaysia is rapidly increasing and there are plenty of reasons why that is happening.
              A web application provides many benefits for varies users since it is versatile with its list of possible functionalities ranging from simple management system to complex payment gateways for online transactions.
              <transition name="fade">
              <span v-show="webAppContent">
               <br><br>Therefore, if you got the ultimate business solution or perhaps the next million-dollar idea, whether it could be the next FoodPanda, Grab, or something even better, just bring us your 'want list' and we will take it from there. We will collaborate closely together and help you achieve your dream with the desired web application that you want.
              </span>
              </transition>
              <div v-show="!webAppContent">
                <a @click="(webAppContent=!webAppContent) (webAppContentText='Read Less')" style="font-size: 15px !important; color: rgb(118, 142, 222)">{{webAppContentText}}</a>
              </div>   
            </p>
          </div>
        </v-flex>
        <v-flex xs12 md5>
          <div style="height: 70%; width: 100%; text-align: center;">
            <img
              style="max-height: 100%; max-width: 100%; padding: 14%"
              src="/img/Web-Avatar-2.svg"
              alt="Web-Avatar-2.svg"
            >
          </div>
        </v-flex>
      </v-layout>
      <!-- 3rd row -->
      <v-layout
      class="pulseAnimationHover"
        id="cms"
        row
        wrap
        align-center
        style="border: 1px solid #dbdee5; margin-bottom: 20px;"
      >
        <v-flex xs12 md5>
          <div style="height: 70%; width: 100%; text-align: center;">
            <img
              style="max-height: 100%; max-width: 100%; padding: 14%"
              src="/img/Web-Avatar-3.svg"
              alt="Web-Avatar-3.svg"
            >
          </div>
        </v-flex>
        <v-flex xs12 md7>
          <div class="px-5 pb-4 pt-3 mb-1">
            <h2
              class="font-weight-bold"
              style="font-size: 28px !important"
            >Customer Management System</h2>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p style="font-size: 15px !important; color: #6d7783">
              With many successful online businesses, there is a need for a customer management system to manage your growing number of customers in an organised manner.
              This helps prevent your business from stalling and optimises your business operation for future expandability.  
              <transition name="fade">
              <span v-show="webCMSContent">
              <br><br>We provide the option of having your very own customer management system integrated with your online business website.
              With a customer management system, tasks such as marketing, sales monitoring, and analytics can be done in an efficient manner that improves your customer’s relationship with your business.
              </span>
              </transition>
              <div v-show="!webCMSContent">
                <a @click="(webCMSContent=!webCMSContent) (webCMSContentText='Read Less')" style="font-size: 15px !important; color: rgb(118, 142, 222)">{{webCMSContentText}}</a>
              </div>  
              

            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Website Capabilitiy -->
    <v-container class="py-0 px-4" justify-center style="margin-top: 100px">
      <v-layout row wrap align-center>
        <!-- 1st row -->
        <v-flex xs12 md6>
          <div>
            <p
              class="font-weight-bold"
              style="font-size: 32px !important;"
            >Our Website Capabilities</p>
            <div style="border: 2px solid #768ede; max-width: 100px; margin: 10px 0 20px 0"></div>
            <p
              class="subheading font-weight-light grey--text"
              style="margin-bottom: 40px"
            >What we can provide for you.</p>

            <div class="slider">
              <input
                type="radio"
                name="slider"
                title="slide1"
                checked="checked"
                class="slider__nav"
              >
              <input type="radio" name="slider" title="slide2" class="slider__nav">
              <div class="slider__inner">
                <div class="slider__contents">
                  <v-container class="pa-0" justify-center>
                    <v-layout justify-center row wrap>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-language-css3</v-icon>
                        <h3 class="font-weight-bold">UI/UX Design</h3>
                        <p>Learn who is your targeted audients and designing it according to their experience in mind.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-clock-fast</v-icon>
                        <h3 class="font-weight-bold">Agile Development Process</h3>
                        <p>Cater for changes and achieve your values in the fastest and most resourceful ways to accelerate your development cycles.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-cellphone</v-icon>
                        <h3 class="font-weight-bold">Responsive and Dynamic Designs</h3>
                        <p>The website design will fit all sizes, no matter the screen size, from mobile devices to 4k resolution screens.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-speedometer</v-icon>
                        <h3 class="font-weight-bold">Performance Matters</h3>
                        <p>The website is built with high performance in mind to preserve a high level of user experience when visiting your website</p>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
                <div class="slider__contents">
                  <v-container class="pa-0" justify-center>
                    <v-layout justify-center row wrap>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-security</v-icon>
                        <h3 class="font-weight-bold">Secure and Safe</h3>
                        <p>Security is a real threat. Hence, all websites will be evaluated to eliminate the existence of potential security risks.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-anchor</v-icon>
                        <h3 class="font-weight-bold">Multilingual Features</h3>
                        <p>Capture a larger group of audience by providing your website with multilingual language support.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-google-glass</v-icon>
                        <h3 class="font-weight-bold">Smart Google Analytics</h3>
                        <p>Monitor, analyse, and track your website's traffic to ensure your business is moving on the right path.</p>
                      </v-flex>
                      <v-flex xs12 sm7 md6 class="capabilities-flex">
                        <v-icon color="blue">mdi-web</v-icon>
                        <h3 class="font-weight-bold">Interactive Banners</h3>
                        <p>Get the best out of your website by displaying interactive banners to promote your on-going activities effectively.</p>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
        <!-- 2nd row -->
        <v-flex xs12 md6>
          <div class="wavy-box">
            <div class="wave -one"></div>
            <div class="wave -two"></div>
            <div class="wave -three"></div>
            <div class="wavy-box hidden-sm-and-down">
              <img style="width: auto; max-height: 490px; z-index: 11;" src="/img/Web-Dev.png" alt>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Navigate to Portfolio -->
    <v-container style="margin-top: 100px; border: 1px solid #dbdee5;">
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6 class="text-xs-center" style="padding: 70px 0;">
          <p
            class="font-weight-black"
            style="font-size: 3.3125rem !important;
    line-height: 1.15em !important; padding-bottom: 20px !important"
          >Still Not Conviced?</p>
          <p
            class="font-weight-thin m-message"
            style="font-size: 24px !important; padding-bottom: 20px !important"
          >
            We'll make you a
            <del class="a-modification -lineThrough">disbeliver</del>
            <ins class="a-modification -underlined">believer</ins>.
          </p>
          <button @click="toPage('Portfolio')" class="btn-portfolio btn-reverse btn-arrow">
            <span>
              See Our Portfolio
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 36.1 25.8"
                enable-background="new 0 0 36.1 25.8"
                xml:space="preserve"
              >
                <g>
                  <line
                    fill="none"
                    stroke="#FFFFFF"
                    stroke-width="3"
                    stroke-miterlimit="10"
                    x1="0"
                    y1="12.9"
                    x2="34"
                    y2="12.9"
                  ></line>
                  <polyline
                    fill="none"
                    stroke="#FFFFFF"
                    stroke-width="3"
                    stroke-miterlimit="10"
                    points="22.2,1.1 34,12.9 22.2,24.7   "
                  ></polyline>
                </g>
              </svg>
            </span>
          </button>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Everowl Technologies',
      // all titles will be injected into this template
      titleTemplate: 'Web Development in Malaysia | Web Design KL | %s',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'We at Everowl Technologies are specialised in creating websites with responsive and dynamic designs as well as cms and web applications for online businesses in Malaysia.'},
        { name: 'keywords', content: 'web design malaysia, web design kl, web app, cms, customer management system, custom website, responsive, dynamic' }
      ]
  },

  data: () => ({
    webDesignContent: false,
    websiteDesignContentText: 'Read More',
    webAppContent: false,
    webAppContentText: 'Read More',
    webCMSContent: false,
    webCMSContentText: 'Read More',
  }),
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    toPage(name) {
      this.$router.push({ name: name });
    }
  },
  mounted() {
    if (this.$store.state.cmsNavigationStatus) {
      var offsets = $("#cms").offset();
      var top = offsets.top;
      this.$store.commit("setCMSNavigationStatus", false);
      setTimeout(() => {
        if (window.innerWidth < 1055) {
          this.$vuetify.goTo(top - 20);
        } else {
          this.$vuetify.goTo(top - 100);
        }
      }, 1000);
    }
  }
};
</script>

<style>

</style>

